import { TRIP_INVITATION_STATUS, TripInvitation } from '~/models/TripInvitation'
import { API_TRIP_INVITATION_STATUS, ApiInvitation } from './apiTypes'

export class TripInvitationEntityMapper {
	static toTripInvitations(apiWidgets: ApiInvitation[]): TripInvitation[] {
		return apiWidgets.map((apiWidget) => this.toTripInvitation(apiWidget))
	}

	static toTripInvitation(apiInvitation: ApiInvitation): TripInvitation {
		const invitation: TripInvitation = {
			id: apiInvitation.id,
			code: apiInvitation.code,
			itineraryId: apiInvitation.itinerary_id,
			role: apiInvitation.role,
			referralId: apiInvitation.referral_id,
			url: apiInvitation.url,
			email: apiInvitation.email,
		}
		if (apiInvitation.status) invitation.status = this.mapStatus(apiInvitation.status)
		return invitation
	}

	private static mapStatus(
		apiStatus: API_TRIP_INVITATION_STATUS
	): TRIP_INVITATION_STATUS | undefined {
		const statusMap: Record<TRIP_INVITATION_STATUS, TRIP_INVITATION_STATUS> = {
			[API_TRIP_INVITATION_STATUS.ACCEPTED]: TRIP_INVITATION_STATUS.ACCEPTED,
			[API_TRIP_INVITATION_STATUS.CANCELLED]: TRIP_INVITATION_STATUS.CANCELLED,
			[API_TRIP_INVITATION_STATUS.PENDING]: TRIP_INVITATION_STATUS.PENDING,
		}
		return statusMap[apiStatus]
	}
}
